<template lang="pug">
  el-form(ref='titles', :inline='true', :model='application.titles.titleConsideration', label-width='150px',
  :disabled='true', size='small')
    el-form-item(label='Τύπος Φοίτησης')
      | {{distant}}
    el-form-item(label='Μερική', v-show="distant === 'Συμβατικός'")
      | {{application.titles.titleConsideration.partTime ? 'Ναι' : 'Όχι'}}
    div(v-show="distant === 'Εξ αποστάσεως'")
      el-form-item(label=' ')
        el-checkbox(label='Μέρος έγινε στην Ελλάδα',
          name='application.titles.titleConsideration.partOfStudiesGr',
          v-model='application.titles.titleConsideration.partOfStudiesGr')
      el-form-item(label='Πόλη', v-show='application.titles.titleConsideration.partOfStudiesGr')
        | {{application.titles.titleConsideration.cityOfStudiesGr}}
      el-form-item(label='Ίδρυμα', v-show='application.titles.titleConsideration.partOfStudiesGr')
        | {{application.titles.titleConsideration.institutionOfStudiesGr}}
    div(v-show="application.degreeType === 'master'")
      el-form-item(label=' ')
        el-checkbox(v-model="application.titles.titleConsideration.greekBachelor")
          | Ελληνικό Βασικό Πτυχίο
      el-form-item(label='Τμήμα', v-show='application.titles.titleConsideration.greekBachelor')
        | {{application.titles.titleConsideration.greekBachelorInserted}}
    hr
    el-form-item(label='Χώρα Σπουδών' v-if='countryExists')
      | {{application.titles.titleConsideration.country.name}}
    el-form-item(label='Χώρα Σπουδών' v-if='application.titles.titleConsideration.country.name === "other"')
      | {{application.titles.titleConsideration.country.countryInserted}}
      div(style='color: red') Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝH Χώρα
    div
      el-form-item(label='Πανεπιστήμιο' v-if='universityExists')
        | {{application.titles.titleConsideration.university.name}}
        el-alert(:closable='false' v-if="omotagesUniversity === 'yes'",
          title='Το ίδρυμα είναι ομοταγές' type='success' show-icon='')
        el-alert(:closable='false' v-if="omotagesUniversity === 'no'",
          title='Το ίδρυμα δεν είναι ομοταγές' type='error' show-icon='')
        el-alert(:closable='false' v-if="omotagesUniversity === 'under investigation'",
          title='Μη κριθέν ίδρυμα' type='warning' show-icon='')
        el-alert(:closable='false' v-if="omotagesUniversity === 'No data found for University.'",
          title='Δε βρέθηκαν στοιχεία για το συγκεκριμένο ίδρυμα' type='warning' show-icon='')
      el-form-item(label='Πανεπιστήμιο' v-if='application.titles.titleConsideration.university.name === "other"')
        | {{application.titles.titleConsideration.university.universityInserted}}
        div(style='color: red') Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝΟ Πανεπιστήμιο
    div
      el-form-item(label='Κολλέγιο', v-if='collegeExists')
        | {{application.titles.titleConsideration.college.name}}
        el-alert(:closable='false' v-if="omotagesCollege === 'yes'",
          title='Το κολέγιο είναι αναγνωρισμένο' type='success' show-icon='')
        el-alert(:closable='false' v-if="omotagesCollege === 'no'",
          title='Το κολέγιο δεν είναι αναγνωρισμένο' type='error' show-icon='')
        el-alert(:closable='false' v-if="omotagesCollege === 'under investigation'",
          title='Μη κριθέν κολέγιο' type='warning' show-icon='')
      el-form-item(label='Κολλέγιο', v-if='application.titles.titleConsideration.college.name === "other"')
        | {{application.titles.titleConsideration.college.collegeInserted}}
        div(style='color: red') Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝΟ Κολλέγιο
    div
      el-form-item(label='Σχολή' v-if='facultyExists')
        | {{application.titles.titleConsideration.faculty.name}}
        el-alert(:closable='false' v-if="omotagesFaculty === 'yes'",
          title='Η σχολή είναι αναγνωρισμένη' type='success' show-icon='')
        el-alert(:closable='false' v-if="omotagesFaculty === 'no'",
          title='Η σχολή δεν είναι αναγνωρισμένη' type='error' show-icon='')
        el-alert(:closable='false' v-if="omotagesFaculty === 'under investigation'",
          title='Μη κριθείσα σχολή' type='warning' show-icon='')
      el-form-item(label='Σχολή', v-if='application.titles.titleConsideration.faculty.name === "other"')
        | {{application.titles.titleConsideration.faculty.facultyInserted}}
        div(style='color: red') Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝΗ ΣΧΟΛΗ
    div
      el-form-item(label='Τμήμα' v-if='departmentExists')
        | {{application.titles.titleConsideration.department.name}}
        el-alert(:closable='false' v-if="omotagesDepartment === 'yes'",
          title='Το τμήμα είναι αναγνωρισμένο' type='success' show-icon='')
        el-alert(:closable='false' v-if="omotagesDepartment === 'no'",
          title='Το τμήμα δεν είναι αναγνωρισμένο' type='error' show-icon='')
        el-alert(:closable='false' v-if="omotagesDepartment === 'under investigation'",
          title='Μη κριθέν τμήμα' type='warning' show-icon='')
      el-form-item(label='Τμήμα', v-if='application.titles.titleConsideration.department.name === "other"')
        | {{application.titles.titleConsideration.department.departmentInserted}}
        div(style='color: red') Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝΟ Τμήμα
    hr
    el-form-item(label='Τίτλος Σπουδών')
      | {{application.titles.titleConsideration.certificationTitle}}
    div
      el-form-item(label='Πιστωτικές Μονάδες')
        | {{application.titles.titleConsideration.credits}}
      el-form-item(label='Διάρκεια Σπουδών')
        | {{application.titles.titleConsideration.durationOfStudies}}
    div
      el-form-item(label='Ημέρ. Εγγραφής')
        | {{application.titles.titleConsideration.dateOfRegistration}}
      el-form-item(label='Ημερ. Αποφοίτησης')
        | {{application.titles.titleConsideration.dateOfGraduation}}
    hr
    el-form-item(label='Οι σπουδές έγιναν')
      el-switch(v-model="application.titles.titleConsideration.studiesInMoreUniversities",
        active-text="σε περισσότερα Πανεπιστήμια",
        inactive-text="σε ένα Πανεπιστήμιο")
    div(v-show='application.titles.titleConsideration.studiesInMoreUniversities')
      div(v-for="(additionalUni, index) in application.titles.titleConsideration.additionalUniversities")
        el-form-item(label='Πανεπιστήμιο' v-show="additionalUni.university != null")
          | {{additionalUni.university}}
        el-form-item(label='Μονάδες' v-show="additionalUni.credits != null")
          | {{additionalUni.credits}}
    hr
</template>

<script>
export default {
  props: ['application', 'omotagesConsideration'],
  data () {
    return {
    }
  },
  computed: {
    departmentExists () {
      return this.application.titles.titleConsideration.department.name !== null &&
        this.application.titles.titleConsideration.department.name !== 'other'
    },
    facultyExists () {
      return this.application.titles.titleConsideration.faculty.name !== null &&
        this.application.titles.titleConsideration.faculty.name !== 'other'
    },
    collegeExists () {
      return this.application.titles.titleConsideration.college.name !== null &&
        this.application.titles.titleConsideration.college.name !== 'other'
    },
    countryExists () {
      return this.application.titles.titleConsideration.country.name !== null &&
        this.application.titles.titleConsideration.country.name !== 'other'
    },
    universityExists () {
      return this.application.titles.titleConsideration.university.name !== null &&
        this.application.titles.titleConsideration.university.name !== 'other'
    },
    omotagesFaculty () {
      return this.omotagesConsideration &&
        this.omotagesConsideration.faculty &&
        this.omotagesConsideration.faculty[0].accredited
    },
    omotagesUniversity () {
      return this.omotagesConsideration &&
        this.omotagesConsideration.university &&
        this.omotagesConsideration.university[0].accredited
    },
    omotagesCollege () {
      return this.omotagesConsideration &&
        this.omotagesConsideration.college &&
        this.omotagesConsideration.college[0].accredited
    },
    omotagesDepartment () {
      return this.omotagesConsideration &&
        this.omotagesConsideration.department &&
        this.omotagesConsideration.department[0].accredited
    },
    distant () {
      return this.application.titles.titleConsideration.distant ? 'Εξ αποστάσεως' : 'Συμβατικός'
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
  .el-form-item {
    color: rgb(30, 0, 128);
    font-weight: bold;
    // border-radius: 10px;
    // border-style: solid;
    // border-color: #7fa3bb green #86b8da yellow;
    // border-width: 0px 0px 2px 0px;
    // border: 2px 0px 0px 0px solid #7fa3bb;
    padding-right: 20px;
  }
  .el-checkbox__input.is-disabled+span.el-checkbox__label {
    color: #1b91de;
  }
  .el-input {
    &.biggest {
      width: 530px;
    }
  }
  .el-input {
    &.big {
      width: 450px
    }
  }
  .el-input--small .el-input__inner {
    width: 300px
  }
  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 190px;
  }
  .el-checkbox__input.is-disabled+span.el-checkbox__label {
    color: #1b91de;
  }
  .el-alert {
  background-color: unset;
  font-style: normal;
  text-align:left;
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/components/common/TitleConsideration.vue